import Logo from 'assets/img/Logo.png';

export {
    Logo,
}